module.exports = __webpack_public_path__ + "static/media/icon5.06b57944.svg";